import { auth } from '../firebase/firebaseConfig';

/** True when a mid-flight auth switch likely caused the Firestore denial. */
export function isStaleFirestorePermissionError(expectedUserId, error) {
  return (
    auth.currentUser?.uid !== expectedUserId &&
    (error?.code === 'permission-denied' ||
      String(error?.message || '').includes('permissions'))
  );
}

/**
 * Wait until Firebase Auth matches the UID Home/Library queries target.
 * Avoids permission-denied during anonymous → permanent account merges.
 */
export async function ensureFirestoreAuthReady(expectedUserId) {
  if (!expectedUserId) return false;

  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user || user.uid !== expectedUserId) return false;

  try {
    await user.getIdToken();
  } catch {
    return false;
  }

  return true;
}
